import * as tf from "@tensorflow/tfjs";
import "@tensorflow/tfjs-backend-webgl";
import "@tensorflow/tfjs-backend-cpu";
import { useEffect, useState } from "react";

export function useRppgModel() {

  const [model, setModel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    let mounted = true;

    async function loadModel() {
      try {

        console.log("⏳ Initializing TensorFlow...");

        // 🔥 Try WebGL first (fastest)
        try {
          await tf.setBackend("webgl");
          console.log("⚡ Using WebGL backend");
        } catch (e) {
          console.warn("WebGL not available, switching to CPU");
          await tf.setBackend("cpu");
        }

        await tf.ready();

        console.log("⏳ Loading rPPG model...");
        const loadedModel = await tf.loadLayersModel("/model/model.json");

        // 🔎 Debug input shape
        console.log("Model input shape:", loadedModel.inputs[0].shape);

        if (mounted) {
          setModel(loadedModel);
          setLoading(false);
          console.log("✅ rPPG model loaded successfully");
        }

      } catch (err) {
        console.error("❌ Model loading failed:", err);
        if (mounted) {
          setError(err);
          setLoading(false);
        }
      }
    }

    loadModel();

    return () => {
      mounted = false;
    };

  }, []);

  return { model, loading, error };
}
